module.exports = __webpack_public_path__ + "img/vue1-languette_vert.a02414f9.png";